import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://f6543c5a031b43ddba85e5fafcef6607@mtrack.xiaomayz.com/12',
});
